export const inviteTeamMemberSuccessMessage = ({ firstName, lastName, email }) => `Invite to ${firstName} ${lastName} (${email}) has been successfully sent!`;
